import { itemsService } from '../services'

const saveRegState = (itemId, status, statusComments) => {
    return new Promise(async (resolve, reject) => {
    await itemsService.saveRegState(itemId, status, statusComments)
        .then(response => resolve(response.data))
        .catch(err => reject({ error: true }))
    })
}
export default saveRegState;